import { useCallback } from 'react';
import { uniqueId } from 'js/utils/methods.util';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';
import uuid from 'uuid-random';

export const useWithdraw = () => {
    const send = useGenericSend();

    return useCallback(async (request: Omit<Types.IWithdrawRequestData, 'uuid'>): Promise<Types.IWithdrawResponseData> => {
        const { data } = await send<Types.IWithdrawRequestData, Types.IWithdrawResponseData>({
            uuid: uuid(),
            ID: 33017,
            description: 'Withdraw',
            responses: [33018, 33019, 33057],
            correlationId: uniqueId('withdraw-'),
            errorLevel: 1,
            ...request
        });

        return data;
    }, [
        send
    ]);
};
